export default [
    {
        name: "generalError",
        path: "/error",
        component: () => import("@/views/error/GeneralErrorView"),
        meta: {
            public: true,
            stepper: false,
        },
    },
    {
        name: "correctErrors",
        path: "/correctErrors",
        component: () => import("@/views/apply/CorrectErrorsView"),
        props: route => ({ applicantType: route.query.applicantType }),
        meta: {
            stepper: false,
        },
    },
    {
        name: "notFound",
        path: "/404",
        component: () => import("@/views/error/NotFoundView"),
        meta: {
            public: true,
            stepper: false,
        },
    },
    {
        name: "sessionInvalid",
        path: "/session/invalid",
        redirect: "/idle",
        meta: {
            public: true,
            stepper: false,
        },
    },
]
